import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCheckCircle } from "react-icons/fa";
import Eclipse from "../../assets/Ellipse.png";
import Profile from "../../assets/Profile.png";
import {
  updateBasicInfo,
  updateImage,
  sendEmailOtp,
  verifyEmailOtp,
} from "../../services/oprations/authAPI";
import toast from "react-hot-toast";
import { useOutletContext } from "react-router-dom";

const ProfileManagement = () => {
  const { darkMode } = useOutletContext();
  const { user } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const [profile, setProfile] = useState({
    name: "",
    email: "",
    avatar: null,
    previewAvatar: null,
  });

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
 

  // Populate name/email from user
  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name || "",
        email: user.email || "",
        avatar: null,
        previewAvatar: null,
      });
    }
  }, [user]);

  // Cleanup avatar preview on unmount
  useEffect(() => {
    return () => {
      if (profile.previewAvatar) {
        URL.revokeObjectURL(profile.previewAvatar);
      }
    };
  }, [profile.previewAvatar]);

  const handleProfileChange = (e) => {
    const { id, value } = e.target;
    setProfile((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setProfile((prev) => ({
        ...prev,
        avatar: file,
        previewAvatar: previewUrl,
      }));
    }
  };

  const handleSave = () => {
    if (profile.name.trim()) {
      dispatch(updateBasicInfo({ name: profile.name.trim() }));
    }

    if (profile.email.trim()) {
      dispatch(updateBasicInfo({ email: profile.email.trim() }));
    }

    if (profile.avatar) {
      dispatch(updateImage(profile.avatar));
    }

    toast.success("Profile updated successfully!");
  };

  const handleVerifyEmail = (e) => {
    e.preventDefault();
    dispatch(sendEmailOtp(profile.email));
    setShowOtpModal(true);
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    dispatch(verifyEmailOtp(user?.email, profile.email, otp));
    setShowOtpModal(false);
  };



  return (
    <div className=" font-sans p-6 min-h-screen">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Top container */}
        <div className="bg-[#f3f7f6] rounded-xl p-8 flex flex-col md:flex-row md:space-x-12 shadow-md">
          {/* Avatar section */}
          <div className="flex flex-col items-center space-y-3 md:w-1/3">
            <div className="relative w-32 h-32">
              {profile.previewAvatar ? (
                <img
                  src={profile.previewAvatar}
                  alt="Preview Avatar"
                  className="w-32 h-32 rounded-full object-cover border-2 border-blue-500"
                />
              ) : user?.image ? (
                <img
                  src={user.image}
                  alt="User Avatar"
                  className="w-32 h-32 rounded-full object-cover border-2 border-gray-300"
                />
              ) : (
                <>
                  <img
                    src={Eclipse}
                    alt="Eclipse Background"
                    className="w-32 h-32 rounded-full"
                  />
                  <img
                    src={Profile}
                    alt="Profile"
                    className="absolute top-1/2 left-1/2 w-16 h-16 transform -translate-x-1/2 -translate-y-1/2"
                  />
                </>
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              id="avatarUpload"
              onChange={handleImageChange}
              className="hidden"
            />

            <label htmlFor="avatarUpload">
              <div className="cursor-pointer bg-[#001f3f] text-white font-semibold rounded-full px-8 py-2 shadow-md hover:shadow-lg transition-shadow text-center">
                Upload Avatar
              </div>
            </label>

            <p className="text-center text-sm text-[#001f3f] font-normal leading-tight">
              Allowed *.jpeg, *.jpg, *.png
              <br />
              Max size of 3MB
            </p>
          </div>

          {/* Profile form */}
          <form className="flex-1 space-y-6 mt-6 md:mt-0">
            <div>
              <label
                htmlFor="name"
                className="block text-[#6b6b6b] font-semibold mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                value={profile.name}
                onChange={handleProfileChange}
                placeholder="Smith John"
                className="w-full rounded-xl py-3 px-4 text-gray-400 placeholder-gray-400 shadow-md focus:outline-none focus:ring-2 focus:ring-[#001f3f]"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className=" block text-[#6b6b6b] font-semibold mb-1"
              >
                Email Address
              </label>
              <div className="flex flex-col md:flex-row md:items-center gap-3">
                <input
                  type="email"
                  id="email"
                  value={profile.email}
                  onChange={handleProfileChange}
                  placeholder="demo@gmail.com"
                  className="flex-1 rounded-xl py-3 px-4 text-gray-700 placeholder-gray-400 shadow-md focus:outline-none focus:ring-2 focus:ring-[#001f3f]"
                />

                {profile.email && profile.email === user?.email ? (
                  <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-xl font-medium">
                    <FaCheckCircle className="text-green-600" /> Verified
                  </span>
                ) : (
                  <button
                    type="button"
                    onClick={handleVerifyEmail}
                    className="bg-[#001f3f] text-white font-semibold px-5 py-3 rounded-xl hover:bg-[#0c1c5c] transition-colors"
                  >
                    Verify
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>

        {/* Connections Section */}
        <div className="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
          {/* Live Stream Connection */}
          {/* <div className="bg-[#f3f7f6] rounded-xl p-6 flex flex-col space-y-4 flex-1 shadow-md">
            <p className="text-[#001f3f] font-semibold text-sm flex items-center gap-2">
              Live Stream Connection
            </p>
            <button
              type="button"
              onClick={handleLiveStreamConnect}
              className="bg-[#001f3f] text-white font-semibold rounded-full px-8 py-3 shadow-md hover:shadow-lg transition-shadow"
            >
              Connect Live Stream
            </button>
          </div> */}

          {/* Export / Import Data */}
          {/* <div className="bg-[#f3f7f6] rounded-xl p-6 flex flex-col space-y-4 flex-1 shadow-md">
            <p className="text-[#001f3f] font-semibold text-sm flex items-center gap-2">
              Data Management
            </p>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange} // Handler now triggers the import action directly
              accept=".csv"
              className="hidden"
            />
            <div className="flex gap-4">
              <button
                type="button"
                onClick={handleExportData}
                className="flex-1 bg-[#001f3f] text-white font-semibold rounded-full px-8 py-3 shadow-md hover:shadow-lg transition-shadow"
              >
                Export Data
              </button>
              <button
                type="button"
                onClick={handleImportButtonClick}
                className="flex-1 bg-[#001f3f] text-white font-semibold rounded-full px-8 py-3 shadow-md hover:shadow-lg transition-shadow"
              >
                Import Data
              </button>
            </div>
          </div> */}
        </div>

        {/* Save Button */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleSave}
            className={`rounded-full px-8 py-3 font-semibold shadow-md hover:shadow-lg transition-colors duration-300 ${
              darkMode
                ? "bg-white text-[#001f3f] hover:bg-gray-100"
                : "bg-[#001f3f] text-white hover:bg-[#0c1c5c]"
            }`}
          >
            Save Changes
          </button>
        </div>

        {/* OTP Modal */}
        {showOtpModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-[#001f3f]">
                Check your email
              </h2>
              <p className="text-gray-600 mb-4">
                We've sent a verification code to <b>{profile.email}</b>.
              </p>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className="w-full rounded-xl py-3 px-4 text-gray-700 placeholder-gray-400 shadow-md focus:outline-none focus:ring-2 focus:ring-[#001f3f] mb-4"
              />
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setShowOtpModal(false)}
                  className="px-5 py-2 rounded-xl bg-gray-300 hover:bg-gray-400 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleVerifyOtp}
                  className="px-5 py-2 rounded-xl bg-[#001f3f] text-white hover:bg-[#0c1c5c] transition-colors"
                >
                  Verify OTP
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileManagement;
